'use strict';

function polygon(ctx, sides, radius, rotation) {
  ctx.beginPath();
  for (let index = 0; index < sides; index += 1) {
    const angle = (Math.PI * 2 * index) / sides + (rotation || -Math.PI / 2);
    const x = Math.cos(angle) * radius;
    const y = Math.sin(angle) * radius;
    if (index === 0) ctx.moveTo(x, y);
    else ctx.lineTo(x, y);
  }
  ctx.closePath();
}

function star(ctx, points, outer, inner) {
  ctx.beginPath();
  for (let index = 0; index < points * 2; index += 1) {
    const radius = index % 2 ? inner : outer;
    const angle = -Math.PI / 2 + (Math.PI * index) / points;
    const x = Math.cos(angle) * radius;
    const y = Math.sin(angle) * radius;
    if (index === 0) ctx.moveTo(x, y);
    else ctx.lineTo(x, y);
  }
  ctx.closePath();
}

function drawShape(ctx, key, r, variant) {
  switch (key) {
    case 'carrot':
      ctx.beginPath(); ctx.moveTo(0, r * 1.7); ctx.lineTo(-r * 0.72, -r * 0.45);
      ctx.quadraticCurveTo(0, -r, r * 0.72, -r * 0.45); ctx.closePath(); ctx.fill(); ctx.stroke();
      ctx.beginPath(); ctx.moveTo(-r * 0.35, -r * 0.55); ctx.lineTo(-r * 0.65, -r * 1.35);
      ctx.moveTo(r * 0.25, -r * 0.58); ctx.lineTo(r * 0.65, -r * 1.3); ctx.stroke(); return;
    case 'bone':
      ctx.beginPath(); ctx.moveTo(-r * 0.75, -r * 0.28); ctx.lineTo(r * 0.75, -r * 0.28);
      ctx.arc(r * 0.78, -r * 0.52, r * 0.34, -Math.PI, Math.PI * 0.45);
      ctx.arc(r * 0.78, r * 0.52, r * 0.34, -Math.PI * 0.45, Math.PI);
      ctx.lineTo(-r * 0.75, r * 0.28);
      ctx.arc(-r * 0.78, r * 0.52, r * 0.34, 0, Math.PI * 1.45);
      ctx.arc(-r * 0.78, -r * 0.52, r * 0.34, Math.PI * 0.55, 0); ctx.fill(); ctx.stroke(); return;
    case 'flame':
      ctx.beginPath(); ctx.moveTo(0, -r * 1.5); ctx.quadraticCurveTo(r * 1.35, -r * 0.15, r * 0.62, r * 1.05);
      ctx.quadraticCurveTo(0, r * 1.6, -r * 0.72, r * 0.88); ctx.quadraticCurveTo(-r * 1.1, 0, 0, -r * 1.5); ctx.fill(); ctx.stroke(); return;
    case 'crystal': polygon(ctx, 6, r * 1.25, Math.PI / 6); ctx.fill(); ctx.stroke(); return;
    case 'crescent':
      ctx.beginPath(); ctx.arc(-r * 0.18, 0, r * 1.18, -Math.PI / 2, Math.PI / 2);
      ctx.arc(r * 0.42, 0, r * 0.86, Math.PI / 2, -Math.PI / 2, true); ctx.closePath(); ctx.fill(); ctx.stroke(); return;
    case 'jar':
      ctx.beginPath(); ctx.moveTo(-r * 0.85, -r * 0.48); ctx.quadraticCurveTo(-r * 0.85, -r * 0.8, -r * 0.52, -r * 0.8);
      ctx.lineTo(r * 0.52, -r * 0.8); ctx.quadraticCurveTo(r * 0.85, -r * 0.8, r * 0.85, -r * 0.48);
      ctx.lineTo(r * 0.85, r * 0.65); ctx.quadraticCurveTo(r * 0.85, r * 0.95, r * 0.52, r * 0.95);
      ctx.lineTo(-r * 0.52, r * 0.95); ctx.quadraticCurveTo(-r * 0.85, r * 0.95, -r * 0.85, r * 0.65); ctx.closePath(); ctx.fill(); ctx.stroke();
      ctx.fillRect(-r * 0.68, -r * 1.15, r * 1.36, r * 0.35); return;
    case 'snowflake':
      ctx.beginPath();
      for (let index = 0; index < 6; index += 1) {
        const angle = (Math.PI * index) / 3; ctx.moveTo(0, 0); ctx.lineTo(Math.cos(angle) * r * 1.35, Math.sin(angle) * r * 1.35);
      }
      ctx.stroke(); ctx.beginPath(); ctx.arc(0, 0, r * 0.34, 0, Math.PI * 2); ctx.fill(); return;
    case 'leaf':
      ctx.beginPath(); ctx.moveTo(0, -r * 1.4); ctx.quadraticCurveTo(r * 1.25, -r * 0.2, 0, r * 1.35);
      ctx.quadraticCurveTo(-r * 1.25, -r * 0.2, 0, -r * 1.4); ctx.fill(); ctx.stroke(); ctx.beginPath(); ctx.moveTo(0, -r); ctx.lineTo(0, r); ctx.stroke(); return;
    case 'blade':
      ctx.beginPath(); ctx.moveTo(0, -r * 1.55); ctx.quadraticCurveTo(r * 0.9, 0, 0, r * 1.55); ctx.quadraticCurveTo(-r * 0.45, 0, 0, -r * 1.55); ctx.fill(); ctx.stroke(); return;
    case 'claw':
      ctx.beginPath();
      [-0.65, 0, 0.65].forEach((offset) => { ctx.moveTo(offset * r, r); ctx.quadraticCurveTo(offset * r + r * 0.45, -r * 0.2, offset * r, -r * 1.25); });
      ctx.stroke(); return;
    case 'star': star(ctx, 5 + (variant % 3), r * 1.35, r * 0.58); ctx.fill(); ctx.stroke(); return;
    case 'dart':
      ctx.beginPath(); ctx.moveTo(0, r * 1.65); ctx.lineTo(-r * 0.55, -r * 0.55); ctx.lineTo(0, -r * 1.18); ctx.lineTo(r * 0.55, -r * 0.55); ctx.closePath(); ctx.fill(); ctx.stroke(); return;
    case 'disc':
      ctx.beginPath(); ctx.ellipse(0, 0, r * 1.35, r * 0.62, 0, 0, Math.PI * 2); ctx.fill(); ctx.stroke();
      ctx.beginPath(); ctx.arc(0, 0, r * 0.28, 0, Math.PI * 2); ctx.stroke(); return;
    case 'droplet':
      ctx.beginPath(); ctx.moveTo(0, -r * 1.45); ctx.bezierCurveTo(r * 1.35, 0, r * 0.85, r * 1.35, 0, r * 1.4);
      ctx.bezierCurveTo(-r * 0.85, r * 1.35, -r * 1.35, 0, 0, -r * 1.45); ctx.fill(); ctx.stroke(); return;
    case 'seed':
      ctx.beginPath(); ctx.ellipse(0, 0, r * 0.68, r * 1.3, 0, 0, Math.PI * 2); ctx.fill(); ctx.stroke(); return;
    case 'cloud':
      ctx.beginPath();
      for (let index = 0; index < 6; index += 1) {
        const angle = (Math.PI * 2 * index) / 6; const rr = r * (0.6 + ((index + variant) % 3) * 0.1);
        ctx.moveTo(Math.cos(angle) * r * 0.58 + rr, Math.sin(angle) * r * 0.5);
        ctx.arc(Math.cos(angle) * r * 0.58, Math.sin(angle) * r * 0.5, rr, 0, Math.PI * 2);
      }
      ctx.fill(); ctx.stroke(); return;
    case 'spike': star(ctx, 7 + (variant % 4), r * 1.4, r * 0.52); ctx.fill(); ctx.stroke(); return;
    case 'horn':
      ctx.beginPath(); ctx.moveTo(0, -r * 1.55); ctx.quadraticCurveTo(r * 1.15, -r * 0.25, r * 0.2, r * 1.35);
      ctx.quadraticCurveTo(-r * 0.45, r * 0.2, 0, -r * 1.55); ctx.fill(); ctx.stroke(); return;
    case 'ring':
      ctx.beginPath(); ctx.arc(0, 0, r * 1.15, 0, Math.PI * 2); ctx.lineWidth = Math.max(3, r * 0.38); ctx.stroke(); return;
    case 'tooth':
      ctx.beginPath(); ctx.moveTo(-r * 0.75, -r); ctx.quadraticCurveTo(0, -r * 1.3, r * 0.75, -r);
      ctx.lineTo(r * 0.38, r * 1.4); ctx.lineTo(0, r * 0.7); ctx.lineTo(-r * 0.38, r * 1.4); ctx.closePath(); ctx.fill(); ctx.stroke(); return;
    case 'shell':
      ctx.beginPath(); ctx.arc(0, 0, r * 1.15, 0, Math.PI * 2); ctx.fill(); ctx.stroke();
      ctx.beginPath(); ctx.arc(0, 0, r * 0.7, 0, Math.PI * 1.7); ctx.lineTo(r * 0.25, 0); ctx.stroke(); return;
    case 'feather':
      ctx.beginPath(); ctx.moveTo(0, -r * 1.45); ctx.quadraticCurveTo(r * 1.15, -r * 0.15, 0, r * 1.42);
      ctx.quadraticCurveTo(-r * 0.65, 0, 0, -r * 1.45); ctx.fill(); ctx.stroke(); ctx.beginPath(); ctx.moveTo(0, -r); ctx.lineTo(0, r * 1.15); ctx.stroke(); return;
    case 'egg':
      ctx.beginPath(); ctx.ellipse(0, r * 0.1, r * 0.88, r * 1.25, 0, 0, Math.PI * 2); ctx.fill(); ctx.stroke(); return;
    case 'spiral':
      ctx.beginPath();
      for (let index = 0; index <= 26; index += 1) {
        const angle = index * 0.48; const radius = r * index / 23;
        const x = Math.cos(angle) * radius; const y = Math.sin(angle) * radius;
        if (index === 0) ctx.moveTo(x, y); else ctx.lineTo(x, y);
      }
      ctx.stroke(); return;
    case 'bubble':
      ctx.globalAlpha *= 0.78; ctx.beginPath(); ctx.arc(0, 0, r * 1.12, 0, Math.PI * 2); ctx.fill(); ctx.stroke();
      ctx.beginPath(); ctx.arc(-r * 0.35, -r * 0.35, r * 0.18, 0, Math.PI * 2); ctx.stroke(); return;
    default:
      ctx.beginPath(); ctx.arc(0, 0, r, 0, Math.PI * 2); ctx.fill(); ctx.stroke();
  }
}

function drawBossProjectile(ctx, projectile) {
  const profile = projectile.profile || {};
  const radius = projectile.radius * (Number(profile.scale) || 1);
  ctx.save();
  ctx.translate(projectile.x, projectile.y);
  ctx.rotate(projectile.heading - Math.PI / 2 + projectile.rotation);
  ctx.fillStyle = profile.primaryColor || '#ff6938';
  ctx.strokeStyle = profile.secondaryColor || '#ffcf54';
  ctx.lineWidth = Math.max(2, radius * 0.16);
  ctx.lineJoin = 'round';
  ctx.lineCap = 'round';
  ctx.shadowColor = profile.primaryColor || '#ff7035';
  ctx.shadowBlur = 10 + (profile.variant || 0);
  drawShape(ctx, profile.rendererKey, radius, profile.variant || 0);
  ctx.restore();
}

module.exports = { drawBossProjectile };
